import {useState, useEffect} from 'react';
import VieworderActionImpl from '../vieworder/VieworderActionImpl';
import {Grid, Button, CircularProgress, Typography} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import { useDispatch, useSelector } from 'react-redux';
import ReferbackAction from '../referback/ReferbackAction';
import { setPharmaorderReferbackModal } from 'store/slice/PharmaSlice';
import { approveOrderAPI, accountsApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import { updatePharmaorderObj, updateProductObj } from 'store/slice/PharmaSlice';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditOrderStory from 'story/EditOrderStory';
import {setEditOrderStory} from 'store/slice/AppSlice';

export default function ApproveorderActionImpl(){
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard)

    useEffect(() => {   
        dispatch(setEditOrderStory({ // Initialize the add order story state
                    title: "Order Review",
                    description: "Order Review",
                    currentState: "ORDER_REVIEW",
                }));
    },[]);
    const orderApproveSuccess = (response)=>{
        setApiInProgress(false);
        setSuccessMsg("Order is approved !!!");
        dispatch(updatePharmaorderObj(response.pharmaorderInfo));
        response.productInfoList.list.map(productObj => dispatch(updateProductObj(productObj)));
    }
    const orderApproveFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const handleOrderSubmit = () =>{
        setErrMsg('')
        setApiInProgress(true);

        if (pharmaorderObj.orderstatus==='ACCOUNTS APPROVAL'){
            accountsApprovalAPI({   
                orderId:pharmaorderObj.id
                }, orderApproveSuccess, orderApproveFailure
            )
        } else if (pharmaorderObj.orderstatus==='MD APPROVAL'){
            approveOrderAPI({   
                orderId:pharmaorderObj.id
                }, orderApproveSuccess, orderApproveFailure
            )
        } else {
            alert('Order Status Mismatch. Please contact IT Support.')
        }

        
    }
    const handleReferBack = () =>{
        dispatch(setPharmaorderReferbackModal(true));
    }
    const getActionPanel = () =>{
        return <>
             <Grid lg={12} container direction="row" sx={{justifyContent: "flex-end",alignItems: "center"}} >
                <Grid item lg={6}>
                    <Typography variant="h4">{pharmaorderObj.orderstatus} <ArrowForwardIcon/> </Typography>
                </Grid>
                <Grid item >
                    <Button variant="contained" color="error" onClick={handleReferBack} startIcon={<CancelIcon />}>Refer Back</Button>
                </Grid>
                &nbsp;&nbsp;&nbsp;
                <Grid item >
                    <Button variant="contained" color="primary" onClick={handleOrderSubmit} startIcon={<CheckIcon />}>Approve</Button>
                </Grid>
            </Grid>
        </>
    }
    const getComponent = () =>{
        if (successMsg!==''){
            return <Grid container direction="row" sx={{justifyContent: "flex-end", padding:2}} >
                <Grid lg={12} item align="right">
                        <SuccessMessage message={successMsg}/>
                </Grid>
            </Grid>
        } else 
        return <>
        <Grid container direction="row" sx={{justifyContent: "space-between",alignItems: "center", padding:2}} >
            <Grid item lg={6}>
                <ErrorMessage message={errMsg}/>
            </Grid>
            <Grid item lg={6}>
            {apiInProgress?<CircularProgress/>:<>
                {getActionPanel()}
            </>}
            </Grid>
        </Grid>
        </>
    }
    return (
        <>
        <EditOrderStory/>
        </>
    )
}